// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"70a774fa","455":"bfc4ad37","829":"773341ce"}[chunkId] + ".chunk.js";
};